/* eslint no-shadow: ["error", { "allow": ["state"] }] */
/* eslint no-param-reassign: ["error", { "props": true, "ignorePropertyModificationsFor": ["state"] }] */

const state = () => ({
    selectedLocation: {
        address: String,
        city: String,
        state: String,
        zip: String,
        country: String,
        latitude: 37.2091709,
        longitude: -93.2503157
    },
    timezone: String,
    isCurrentLocation: false,
    fitBounds: true,
    geoLocationLoading: true
});

const mutations = {
    updateSelectedLocation(state, location) {
        state.selectedLocation = location;
    },
    updateTimezone(state, timezone) {
        state.timezone = timezone;
    },
    setIsCurrentLocation(state, value) {
        state.isCurrentLocation = value;
    },
    updateFitBounds(state, value) {
        state.fitBounds = value;
    },
    updateGeoLocationLoading(state, value) {
        state.geoLocationLoading = value;
    }
};

const actions = {
    selectNewLocation({ commit }, location) {
        commit('updateSelectedLocation', location);
    },
    setGeoLocationLoading({ commit }, loading) {
        commit('updateGeoLocationLoading', loading);
    },
    selectSearchedLocation({ commit, dispatch }, location, fitBounds) {
        commit('setIsCurrentLocation', false);
        dispatch('selectNewLocation', location);
        dispatch('setFitBounds', fitBounds);
    },
    selectGeoLocation({ commit, dispatch }, location) {
        commit('setIsCurrentLocation', true);
        dispatch('setGeoLocationLoading', false);
        dispatch('selectNewLocation', location);
        dispatch('setFitBounds', true);
    },
    setTimezone({ commit }, timezone) {
        commit('updateTimezone', timezone);
    },
    setFitBounds({ commit }, fitBounds) {
        commit('updateFitBounds', fitBounds);
    }
};

const getters = {
    selectedLocation: state => state.selectedLocation,
    timezone: state => state.timezone,
    isCurrentLocation: state => state.isCurrentLocation,
    geoLocationLoading: state => state.geoLocationLoading
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
};
